// @ts-nocheck
import {useEffect, useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row, usePagination} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {usersColumns} from './columns/_columns'
import {User} from '../core/_models'
import {KTCardBody, KTSVG} from '../../../../../_metronic/helpers'
import {useListView} from '../../../../modules/apps/user-management/users-list/core/ListViewProvider'
import {CustomRow} from './columns/CustomRow'
import {gql, useLazyQuery, useQuery} from '@apollo/client'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {UsersListPagination} from '../components/pagination/UsersListPagination'
import useFeedback from '../../../../hooks/useFeedBack'
import useCommunity from '../../../../hooks/useCommunity'
import useTicket from '../../../../hooks/useTicket'

type SearchProps = {
  userSearch: String
  setUserSearch: Function
}
export let AllUsersData
let searchUsers = []

const clean = (text) => text.replace(/[^a-zA-Z0-9 ]/g, '')

const UsersTable = ({
  sDate,
  eDate,
  genderFilter,
  setGenderFilter,
  userSearch,
  setUserSearch,
  page,
  subscription,
  setPage,
  setUD,
}: SearchProps) => {
  let gender = genderFilter
  const [pageSize, setPageSize] = useState(10)
  const [loadingTrue, setLoadingTrue] = useState<boolean>(false)
  const startDate = sDate == '' ? '' : new Date(sDate).toLocaleString()
  const endDate = eDate == '' ? '' : new Date(eDate).toLocaleString()
  const [paginationDetails, setPaginationDetails] = useState({})
  const [usersData, setUsersData] = useState([])
  const [loading, setLoading] = useState(false)

  const {getTickets} = useTicket()

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      if (userSearch) {
        setPage(1)
      }

      const {data, error} = await getTickets(page, pageSize, sDate, eDate, '', '', userSearch)

      // Debug: Log first ticket to check user data
      if (data?.getTicketsPaginated?.tickets?.length > 0) {
        console.log('🎫 First ticket data:', data.getTicketsPaginated.tickets[0])
        console.log('👤 User data:', data.getTicketsPaginated.tickets[0]?.user)
        console.log('📧 User name:', data.getTicketsPaginated.tickets[0]?.user?.first_name, data.getTicketsPaginated.tickets[0]?.user?.last_name)
      }

      setUsersData(data?.getTicketsPaginated?.tickets)
      setUD(data?.getTicketsPaginated?.tickets)
      setPaginationDetails(data?.getTicketsPaginated)
      setLoading(false)
    }

    init()
  }, [page, startDate, endDate, userSearch, pageSize])

  const data = useMemo(() => usersData, [usersData])
  const columns = useMemo(() => usersColumns, [])

  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  // const {selected} = useListView()
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<User>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <UsersListPagination
        page={page}
        setPage={setPage}
        setPageSize={setPageSize}
        pageSize={pageSize}
        totalPages={
          page + 5 < paginationDetails.totalPages ? page + 5 : paginationDetails.totalPages
        }
        loading={loading}
        paginationDetails={paginationDetails}
      />
      {loading && <UsersListLoading />}
      {/* {isFetching && <UsersListLoading />} */}
    </KTCardBody>
  )
}

export {UsersTable}
